import * as XLSX from "xlsx";

/** Columnas de la herramienta oficial DGII Formato 606 (versión 2020.2). */
export const COLUMNAS_606 = [
  { id: "rnc_cedula", label: "RNC o Cédula" },
  { id: "tipo_id", label: "Tipo Id" },
  { id: "tipo_bienes_servicios", label: "Tipo Bienes y Servicios Comprados" },
  { id: "ncf", label: "NCF" },
  { id: "ncf_modificado", label: "NCF o Documento Modificado" },
  { id: "fecha_comprobante", label: "Fecha Comprobante" },
  { id: "fecha_pago", label: "Fecha Pago" },
  { id: "monto_servicios", label: "Monto Facturado en Servicios" },
  { id: "monto_bienes", label: "Monto Facturado en Bienes" },
  { id: "total_facturado", label: "Total Monto Facturado" },
  { id: "itbis_facturado", label: "ITBIS Facturado" },
  { id: "itbis_retenido", label: "ITBIS Retenido" },
  { id: "itbis_proporcionalidad", label: "ITBIS sujeto a Proporcionalidad (Art. 349)" },
  { id: "itbis_costo", label: "ITBIS llevado al Costo" },
  { id: "itbis_adelantar", label: "ITBIS por Adelantar" },
  { id: "itbis_percibido", label: "ITBIS percibido en compras" },
  { id: "tipo_retencion_isr", label: "Tipo de Retención en ISR" },
  { id: "monto_retencion_renta", label: "Monto Retención Renta" },
  { id: "isr_percibido", label: "ISR Percibido en compras" },
  { id: "isc", label: "Impuesto Selectivo al Consumo" },
  { id: "otros_impuestos", label: "Otros Impuesto/Tasas" },
  { id: "propina_legal", label: "Monto Propina Legal" },
  { id: "forma_pago", label: "Forma de Pago" },
];

export const NOMBRE_HOJA_606 = "Herramienta Formato 606";

export const periodoDesdeFecha = (fecha) => {
  const t = String(fecha || "").trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(t)) return "";
  return `${t.slice(0, 4)}${t.slice(5, 7)}`;
};

export const nombreArchivo606 = (periodo) => {
  const p = String(periodo || "").replace(/\D/g, "").slice(0, 6);
  return p ? `606_${p}.xlsx` : "606.xlsx";
};

export const construirMatriz606 = ({ rncEmpresa, periodo, filas }) => {
  const registros = Array.isArray(filas) ? filas : [];
  const headers = COLUMNAS_606.map((c) => c.label);
  const data = registros.map((f) =>
    COLUMNAS_606.map((c) => {
      const v = f?.[c.id];
      return v == null ? "" : v;
    })
  );
  return [
    ["Dirección General de Impuestos Internos"],
    ["Formato de Envío de Compras de Bienes y Servicios"],
    [],
    [
      "RNC",
      rncEmpresa || "",
      "Periodo",
      periodo || "",
      "Cantidad Registros",
      registros.length,
    ],
    [],
    headers,
    ...data,
  ];
};

export const descargarFormato606 = (matriz, nombreArchivo) => {
  const ws = XLSX.utils.aoa_to_sheet(matriz);
  ws["!cols"] = COLUMNAS_606.map((c) => ({
    wch: Math.min(Math.max(String(c.label).length + 2, 14), 42),
  }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, NOMBRE_HOJA_606.slice(0, 31));
  XLSX.writeFile(wb, nombreArchivo || "606.xlsx");
};
